import { ValidatorFn, AbstractControl, ValidationErrors } from "@angular/forms";
import { isNullOrUndefined } from "util";
export class DateValidators {
    static DateRangeValidator(): ValidatorFn {
        return (control: AbstractControl): ValidationErrors => {
          const dateRange = <Date[]> control.value;

          if (isNullOrUndefined(dateRange) || !Array.isArray(dateRange) || dateRange.length <= 1) {
            return {
              invalidDateRange: true
            };
          }
          else {
            return null;
          }
        };
    }
}


// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/shared/validators/date.validators.ts